import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-menu-lateral',
  templateUrl: './menu-lateral.component.html',
  styleUrls: ['./menu-lateral.component.scss']
})
export class MenuLateralComponent implements OnInit {

  constructor(public router: Router) { }
  bnd_menu_desa=false;
  bnd_menu_chart=false;
  bnd_menu_crm=false;
  bnd_menu_adm=false;

  despl_desa=false;
  despl_chart=false;
  despl_crm=false;
  despl_adm=false;
  bnd_menu_capacitacion=false;
  
  bnd_role=false;
  bnd_estructura=false;
  bnd_persona=false;
  bnd_competencias=false;

  bnd_org=false;
  bnd_raci=false;
  bnd_servicios=false;
  bnd_tkt=false;
  bnd_hk=false;
  bnd_desp=false;

  bnd_cal=false;
  bnd_pro=false;
  bnd_celen=false;
  bnd_task=false;  
  
  bnd_usu=false;
  bnd_edtcli=false;
  bnd_dc3=false ;
  bnd_capacit=false;
  despl_capa=false;
  despl_rh=false;
  despl_chart2=false;
  v_desa(d){
    this.despl_desa=false;
    this.despl_chart=false;
    this.despl_crm=false;
    this.despl_adm=false;
    this.despl_rh=false;
    this. despl_chart2=false;
    this.despl_capa=false;
    switch (d) {
      case "capa":
        this.despl_capa=true;
        break;
      case "rh":
        this.despl_rh=true;
        break;
      case "desa":
        this.despl_desa=true;
        break;
        case "chart":
          this.despl_chart=true;
          break;
          case "chart2":
          this.despl_chart2=true;
          break;
          case "crm":
            this.despl_crm=true;
            break;
            case "adm":
            this.despl_adm=true;
            break;
      default:
        break;
    }
  }
  despliega_menu(){
    this.bnd_menu_desa=false;
    this.bnd_menu_chart=false;
    this.bnd_menu_crm=false;
    this.bnd_menu_adm=false;
    this.bnd_menu_capacitacion=false;
    
    this.bnd_role=false;
      this.bnd_estructura=false;
      this.bnd_persona=false;
      this.bnd_competencias=false;    
      this.bnd_org=false;
      this.bnd_raci=false;
      this.bnd_servicios=false;
      this.bnd_tkt=false;
      this.bnd_hk=false;
      this.bnd_desp=false;    
      this.bnd_cal=false;
      this.bnd_pro=false;
      this.bnd_celen=false;
      this.bnd_task=false;      
      this.bnd_usu=false;
      this.bnd_edtcli=false;      
      this.bnd_capacit=false;
    if(localStorage.getItem("garoce")=="1"){
      this.bnd_menu_desa=true;
      this.bnd_menu_chart=true;
      this.bnd_menu_crm=true;
      this.bnd_menu_adm=true;
      this.bnd_menu_capacitacion=true;
      this.bnd_role=true;
      this.bnd_estructura=true;
      this.bnd_persona=true;
      this.bnd_competencias=true;    
      this.bnd_org=true;
      this.bnd_raci=true;
      this.bnd_servicios=true;
      this.bnd_tkt=true;
      this.bnd_hk=true;
      this.bnd_desp=true;    
      this.bnd_cal=true;
      this.bnd_pro=true;
      this.bnd_celen=true;
      this.bnd_task=true;      
      this.bnd_usu=true;
      this.bnd_edtcli=true;      
      this.bnd_capacit=true;
          
    }else{
    if(this.modulos.length>0){
      for(var i=0;i<this.modulos.length;i++){        
        switch (Number(this.modulos[i])) {
          case 1:this.bnd_raci=true;this.bnd_menu_chart=true;break;
          case 2:this.bnd_servicios=true;this.bnd_menu_chart=true;break;
          case 3:this.bnd_tkt=true;this.bnd_menu_chart=true;break;
          case 4:this.bnd_hk=true;this.bnd_menu_chart=true;break;
          case 5:this.bnd_desp=true;this.bnd_menu_chart=true;break;
          case 12:this.bnd_org=true;this.bnd_menu_chart=true;break;

          case 6:this.bnd_pro=true;this.bnd_menu_crm=true;break;
          case 7:this.bnd_cal=true;this.bnd_menu_crm=true;break;
          case 8:this.bnd_task=true;this.bnd_menu_crm=true;break;
          case 9:this.bnd_celen=true;this.bnd_menu_crm=true;break;
          
          case 10:this.bnd_capacit=true;this.bnd_menu_capacitacion=true;break;
          case 18:this.bnd_capacit=true;this.bnd_menu_capacitacion=true;break;
         
          case 17:this.bnd_competencias=true;this.bnd_menu_desa=true;break;
          case 13:this.bnd_estructura=true;this.bnd_menu_desa=true;break;
          case 14:this.bnd_persona=true;this.bnd_menu_desa=true;break;
          case 15:this.bnd_role=true;this.bnd_menu_desa=true;break;          
          case 19:
            case 20:
            case 21:
              this.bnd_dc3=true;
            break; 
          case 11:this.bnd_usu=true;this.bnd_menu_adm=true;break;
          case 16:this.bnd_edtcli=true;this.bnd_menu_adm=true;break;    
        }
      }
      }
    }
   
  } 

  modulos;
  nombre;
  ngOnInit() {        
    if(!localStorage.getItem('garoce')){      
      this.router.navigate(['/login']);
    }
    this.nombre=localStorage.getItem("nom_cliente");
    try {
      this.modulos=localStorage.getItem("modulos").split(",")  
    } catch (error) {
      this.modulos=[];
    }
    
    this.despliega_menu();
    setTimeout(function(){
      this.bndmnugral=false;
    },5000)
  }
  _go(a){
    //localStorage.setItem("menu_","1");    
    this.router.navigate([a]);
  }
}
